import { calculateOptionScores } from "../shared/decision-engine";
import type { Criterion, DecisionOption } from "../shared/types";

interface DecisionScaleProps {
  criteria: Criterion[];
  options: DecisionOption[];
}

export function DecisionScale({ criteria, options }: DecisionScaleProps) {
  const ranked = calculateOptionScores(criteria, options);
  const left = ranked[0]?.score ?? 50;
  const right = ranked[1]?.score ?? left;
  const tilt = Math.max(-6, Math.min(6, (right - left) * 0.25));

  return (
    <section className="scale" aria-label="決策天平">
      <div className="scale__labels">
        {ranked.slice(0, 2).map((option, index) => (
          <div key={option.id} className={index === 0 ? "scale__leader" : ""}>
            <span>{option.label}</span>
            <strong>{option.score}</strong><small>/ 100</small>
          </div>
        ))}
      </div>
      <div className="scale__beam-wrap">
        <div className="scale__beam" style={{ transform: `rotate(${tilt}deg)` }}>
          <span className="scale__pan scale__pan--left" />
          <span className="scale__pan scale__pan--right" />
        </div>
        <div className="scale__fulcrum" />
      </div>
      <p>分數是思考工具，不是答案。調整下面的權重，看看結論是否穩定。</p>
    </section>
  );
}
